import { ColumnModel, SelectionSettingsModel } from '@syncfusion/ej2-react-grids';

export const EnrollmentGridColumns: ColumnModel[] = [
    {
        type: 'checkbox',
        width: '50'
    },
    {
        field: 'enrollmentID',
        headerText: 'Enrollment ID',
        type: 'text',
        clipMode: 'EllipsisWithTooltip',
        allowSorting: true,
        isPrimaryKey: true,
        width: '120'
    },
    {
        field: 'lastName',
        headerText: 'Last Name',
        type: 'text',
        clipMode: 'EllipsisWithTooltip',
        allowSorting: true,
        width: '120'
    },
    {
        field: 'dateOfBirth',
        headerText: 'Birth Date',
        type: 'Date',
        clipMode: 'EllipsisWithTooltip',
        allowSorting: true,
        format: 'MM/dd/y',
        width: '120'
    },
    {
        field: 'medicareId',
        headerText: 'HIC',
        type: 'text',
        clipMode: 'EllipsisWithTooltip',
        allowSorting: true,
        width: '120'
    },
    {
        field: 'enrollmentSource',
        headerText: 'Source',
        type: 'text',
        clipMode: 'EllipsisWithTooltip',
        allowSorting: true,
        width: '150'
    },
    {
        field: 'assignedMemberRep',
        headerText: 'Assigned Member Rep',
        type: 'text',
        clipMode: 'EllipsisWithTooltip',
        allowSorting: true,
        width: '150'
    },
    {
        field: 'processingStatus',
        headerText: 'Status',
        type: 'text',
        clipMode: 'EllipsisWithTooltip',
        allowSorting: true,
        width: '150'
    },
    {
        field: 'automationFailedReason',
        headerText: 'Automation Failed Reason',
        type: 'text',
        clipMode: 'EllipsisWithTooltip',
        allowSorting: true,
        width: '180'
    }
];

export const TransactionEventsGridColumns: ColumnModel[] = [
    {
        field: 'automationStatus',
        headerText: 'Status',
        width: 30,
        type: 'text',
        allowSorting: true,
        clipMode: 'EllipsisWithTooltip'
    },
    {
        field: 'automationNotes',
        headerText: 'Notes',
        width: 200,
        type: 'text',
        allowSorting: true,
        clipMode: 'EllipsisWithTooltip'
    },
    {
        field: 'createdOn',
        headerText: 'Created On',
        width: 30,
        type: 'date',
        allowSorting: true,
        format: 'MM/dd/yyyy'
    },
    {
        field: 'isRequeued',
        headerText: 'Is Requeued',
        width: 30,
        allowSorting: true,
        template: (props: any) => (props.isRequeued ? 'Yes' : 'No')
    },
    {
        field: 'requeueOrder',
        headerText: 'Requeue Order',
        width: 30,
        type: 'number',
        allowSorting: true,
        template: (props: any) => (props.requeueOrder == 0 ? '-' : props.requeueOrder)
    }
];

export interface TransactionEvent {
    automationStatus: string;
    automationNotes: string;
    createdOn: string;
    isRequeued: boolean;
    requeueOrder: number;
}

export interface EnrollmentResult {
    enrollmentID: number;
    instanceId?: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    homeZipCode: string;
    medicareId: string;
    enrollmentSource: string;
    assignedMemberRep: string;
    processingStatus: string;
    automationFailedReason: string;
    automationStatus: string;
    retryCount: number;
    transactionEvents: TransactionEvent[];
}

export const tabsToolbarOptions = [
    {
        id: 'requeue',
        text: 'Requeue',
        tooltipText: 'Requeue',
        align: 'Left',
    },
];

export const selectionSettings: SelectionSettingsModel = {
    type: 'Multiple',
    persistSelection: true,
    checkboxOnly: true,
};